import type { TLayer } from '../components/modal/ModalContext';

export const Z_MODAL_LAYER_1_OVERLAY = 100;
export const Z_MODAL_LAYER_1_CONTENT = 110;
export const Z_MODAL_LAYER_2_OVERLAY = 200;
export const Z_MODAL_LAYER_2_CONTENT = 210;
export const Z_MODAL_LAYER_3_OVERLAY = 300;
export const Z_MODAL_LAYER_3_CONTENT = 310;
export const Z_DROPDOWN = 400;
export const Z_TOAST = 500;

export const getModalLayerZ = (
  layer: TLayer,
): { overlay: number; content: number } => {
  switch (layer) {
    case 1:
      return {
        overlay: Z_MODAL_LAYER_1_OVERLAY,
        content: Z_MODAL_LAYER_1_CONTENT,
      };
    case 2:
      return {
        overlay: Z_MODAL_LAYER_2_OVERLAY,
        content: Z_MODAL_LAYER_2_CONTENT,
      };
    case 3:
      return {
        overlay: Z_MODAL_LAYER_3_OVERLAY,
        content: Z_MODAL_LAYER_3_CONTENT,
      };
    default: {
      const unreachableLayer: never = layer;
      throw new Error(`Unsupported modal layer: ${String(unreachableLayer)}`);
    }
  }
};
